import { memo } from 'react';

import Editor from './Editor';

export * from './types';

export default memo(Editor);
